import React from 'react'
import PropTypes from 'prop-types'
import TooltipComponent from '../utils/TooltipComponent'
import IconComponent from './IconComponent'
import ButtonComponent from './ButtonComponent'

const UpdateButtonComponent = ({ onClick, children, disabled }) => {
  return (
    <TooltipComponent content="Update" id="update-tooltip" placement="top">
      <ButtonComponent type="button" color="primary mb-1" onClick={onClick}  disabled={disabled}>
        <IconComponent icon="hugeicons:work-update" height="18"  />
        &nbsp;{children}
      </ButtonComponent>
    </TooltipComponent>
  )
}

UpdateButtonComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node,
}

export default UpdateButtonComponent
